module.exports = __webpack_public_path__ + "img/ico-report-watermark.702d033e.svg";